export const isTeamsApp = () => {
  return (
    localStorage.getItem('integrationMode') === 'teams' ||
    window.location.href.includes('teams.microsoft.com') ||
    window.location.href.includes('outlook.office.com') ||
    window.location.href.includes('m365.cloud.microsoft') ||
    window.navigator.userAgent.includes('Teams/') ||
    window.navigator.userAgent.includes('Outlook') ||
    window.navigator.userAgent.includes('Office')
  );
};

export const getEnvironment = (): 'teams' | 'web' => {
  if (isTeamsApp()) {
    return 'teams';
  }
  return 'web';
};
